export const CreatePayment = (api, payment, paymentType) => {
    var paymentDetails = {
        TransactionId: payment.orderId,
        DocOrderId: payment.docOrderId,
        DocOrderDate: payment.docOrderDate,
        SiteId: payment.siteId,
        UserId: payment.userId,
        CustId: payment.custId,
        Amount: payment.amount,
        CustomerEmail: payment.customerEmail,
        PaymentTitle: payment.paymentTitle,
        GatewayId: payment.gatewayId,
        PaymentExpDate: payment.paymentExpDate,
        RemoteId: ''
    }
    return api.post(`/api/v1/Payment/createElavonPayment`, paymentDetails)
    if (paymentType === 'Autopay') {
        return api.post(`/api/v1/Payment/CreateAutopayPayment`, paymentDetails)
    }
    else {
        return api.post(`/api/v1/Payment/createElavonPayment`, paymentDetails)
    }
}

export const GetOrderPaymentData = (api, paymentGuid) => {
    return api.get(`/api/v1/Payment/getOrderPaymentData?paymentGuid=${paymentGuid}`)
}

export const CollectElavonPaymentStatus = (api, paymentId, siteId) => {
    return api.get(`/api/v1/Payment/collectElavonPaymentStatus?paymentId=${paymentId}&siteId=${siteId}`)
}

export const GetActivePaymentSuppliersForSites = (api) => {
    return api.get(`/api/v1/Payment/getActivePaymentSuppliersForSites`)
}

export const ChangeTaskStatusIfNeeded = (api, remoteId) => {
    return api.post(`/api/v1/Payment/changeTaskStatusIfNeeded?remoteId=${remoteId}`)
}
